export default __webpack_public_path__ + "static/media/avatar13.e6315afa.svg";